import script from "./result.vue?vue&type=script&setup=true&lang=ts"
export * from "./result.vue?vue&type=script&setup=true&lang=ts"

import "./result.vue?vue&type=style&index=0&id=724e3d90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-724e3d90"]])

export default __exports__